import { post, get } from '../../../../services/request';

//------------------- Rad Hourly Volume Share - start ------------------//
// Get Provider Facility Unread RVU Details
export const getRadSiteUnReadRvuDetails = (payload) => {
    return post('RadSiteEnterprise/GetRadSiteEnterpriseUnReadRUVDetails', payload);
};

// Get Provider Facility Read RVU Details
export const getRadSiteReadRvuDetails = (payload) => {
    return post('RadSiteEnterprise/GetRadSiteEnterpriseReadRUVDetails', payload);
};

// Export for Rad Hourly Volume Share to CSV
export const exportRadHourlyVolumeShare = (url, payload) => {
    return post(url, payload);
};

// Get Dropdown Provider Facilities
export const getDropdownRadSites = () => {
    return get('RadSiteEnterprise/GetRadSiteEnterpriseDropDown');
};

// get Worklist ID by RPCE IDs
export const getWorklistID = (payload) => {
    return post(`Common/GetWorkListByRPCEIds?rpceIds=${payload}`);
}

// get Practices by Worklist ID
export const GetPracticesByWorklistID = (payload) => {
    return get(`Common/GetPracticesByWorklistIds?worklistIds=${payload}`);
}

// get Practices by Worklist ID
export const GetSubPracticesByPracticeID = (payload) => {
    return get(`Common/GetSubPracticesByPracticeIDs?PracticeIDs=${payload}`);
}

// get Facilities by Sub Practice ID
export const GetSiteBySubPracticeID = (payload) => {
    return get(`Common/GetSiteBySubPracticeIDs?SubPracticeIDs=${payload}`);
}
//-------------------Rad Hourly Volume Share - end----------------//